// accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    content.style.maxHeight = 'max-content';
  };
  
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };
  
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    if(intro){
        intro.onclick = (e) => {
          if (content.style.maxHeight) {
            closeAccordion(accordion);
          } else {
            accordions.forEach((accordion) => closeAccordion(accordion));
            openAccordion(e.target.closest('[js-acc-item]'));
          }
        };
    }
  });   
}
faq_taggol();
// accordions js end

// faq tabs toggal start
function togal_tabs (item) {
  item.addEventListener("click", () => {
     toggal_all_tabs(item.getAttribute('data-faq_content'));
  });        
}
function toggal_all_tabs(tabs_data){
  let tabs_button = document.querySelectorAll("[data-faq_content]");
  tabs_button.forEach(b => {
    if(b.getAttribute('data-faq_content') == tabs_data){
      if(b.classList.contains('is_open')){
         b.classList.remove("is_open");    
        }else{
         b.classList.add("is_open");
        }
    }else{
       b.classList.remove("is_open");
    }
  });             
}
function cm_faq_taggol() {
  let tabs_title = document.querySelectorAll("[data-faq_content]");
  tabs_title.forEach(togal_tabs);
}
cm_faq_taggol();
// faq tabs toggal end

// faq tabs toggal content start
function tab_mai_mappert(item) {
  item.addEventListener("click", () => {
     toggal_all_tabs_content(item.getAttribute('data-hendles'));
  });
}
function toggal_all_tabs_content(tabs_data){
  let tabs_content_toggel = document.querySelectorAll("[data-hendles]");
  tabs_content_toggel.forEach(b => {
    if(b.getAttribute('data-hendles') == tabs_data){
         b.classList.add("active");
        document.querySelector(b.getAttribute('data-hendles')).classList.remove("hidden");
        // document.querySelector(b.getAttribute('data-hendles')).classList.add("active");
    }else{
       b.classList.remove("active");
      if (document.querySelector(b.getAttribute('data-hendles'))) {
         document.querySelector(b.getAttribute('data-hendles')).classList.add("hidden");
         // document.querySelector(b.getAttribute('data-hendles')).classList.remove("active");
      }                                 
    }
  });
}
let tabs_content  = document.querySelectorAll("[data-hendles]");
tabs_content.forEach(tab_mai_mappert);
// faq tabs toggal content end

$(document).on("click", ".toggle-sort", function() {
   $('.collection-filter__item').toggleClass('custom_drop');
});


// price range collection page

// price filter slider
  const rangeMin = document.querySelector('.range-min');
  const rangeMax = document.querySelector('.range-max');
  const minValueInput = document.querySelector('.minvalue');
  const maxValueInput = document.querySelector('.maxvalue');
  const minValueText = document.querySelector('.min_price');
  const maxValueText = document.querySelector('.max_price');
  const progress = document.querySelector('.price-range-progress');
  
  function updateInputs() {
    if (minValueInput) minValueInput.value = rangeMin.value;
    if (maxValueInput) maxValueInput.value = rangeMax.value;
    if (minValueText) minValueText.innerHTML = theme.Currency.formatMoney(rangeMin.value, theme.settings.moneyFormat);
    if (maxValueText) maxValueText.innerHTML = theme.Currency.formatMoney(rangeMax.value, theme.settings.moneyFormat);
  }

  function updateSlider() {
    if (minValueInput || maxValueInput) {
      rangeMin.value = minValueInput.value;
      rangeMax.value = maxValueInput.value;
    }
    updateProgress();
  }

  function updateProgress() {
    if(rangeMin || rangeMax ){
      const minPercent = (rangeMin.value / rangeMin.max) * 100;
      const maxPercent = (rangeMax.value / rangeMax.max) * 100;
      progress.style.left = minPercent + '%';
      progress.style.right = (100 - maxPercent) + '%';
    }
  }

  if (rangeMin) {
    rangeMin.addEventListener('input', () => {
      if (parseInt(rangeMin.value) > parseInt(rangeMax.value)) {
        rangeMin.value = rangeMax.value;
      }
      updateInputs();
      updateProgress();
    });
  }
  
  if (rangeMax) {
    rangeMax.addEventListener('input', () => {
      if (parseInt(rangeMax.value) < parseInt(rangeMin.value)) {
        rangeMax.value = rangeMin.value;
      }
      updateInputs();
      updateProgress();
    });
  }
  if(minValueInput){
    minValueInput.addEventListener('change', () => {
      if (parseInt(minValueInput.value) > parseInt(rangeMax.value)) {
        minValueInput.value = rangeMax.value;
      }
      updateSlider();
    });
  }

  if(maxValueInput){
    maxValueInput.addEventListener('change', () => {
      if (parseInt(maxValueInput.value) < parseInt(rangeMin.value)) {
        maxValueInput.value = rangeMin.value;
      }
      updateSlider();
    });
  }
  // Initial update
  updateInputs();
  updateProgress();

// price range for mobile 

  const mobileRangeMin = document.querySelector('.mobile-range-min');
  const mobileRangeMax = document.querySelector('.mobile-range-max');
  const mobileMinValueInput = document.querySelector('.Mobile-Filter--minvalue');
  const mobileMaxValueInput = document.querySelector('.Mobile-Filter--maxvalue');
  const mobileminValueText = document.querySelector('.mobile_min_price');
  const mobilemaxValueText = document.querySelector('.mobile_max_price');
  const mobileProgress = document.querySelector('.mobile-price-rang');
  const removeButton = document.querySelector('.mobile-price-range');

  if (!mobileRangeMin || !mobileRangeMax || !mobileMinValueInput || !mobileMaxValueInput || !mobileProgress) {
    console.log('One or more elements not found. Check your HTML structure and class names.');
  }

  function mobileupdateInputs() {
    if(mobileMinValueInput || mobileMaxValueInput ){
      mobileMinValueInput.value = mobileRangeMin.value;
      mobileMaxValueInput.value = mobileRangeMax.value;
      if (mobileminValueText) mobileminValueText.innerHTML = theme.Currency.formatMoney(mobileRangeMin.value, theme.settings.moneyFormat);
     if (mobilemaxValueText) mobilemaxValueText.innerHTML = theme.Currency.formatMoney(mobileRangeMax.value, theme.settings.moneyFormat);
    }
  }

  function mobileupdateSlider() {
    mobileRangeMin.value = mobileMinValueInput.value;
    mobileRangeMax.value = mobileMaxValueInput.value;
    mobileupdateProgress();
  }

  function mobileupdateProgress() {
    if(mobileRangeMin || mobileRangeMax ){
      const minPercent = (mobileRangeMin.value / mobileRangeMin.max) * 100;
      const maxPercent = (mobileRangeMax.value / mobileRangeMax.max) * 100;
      mobileProgress.style.left = minPercent + '%';
      mobileProgress.style.right = (100 - maxPercent) + '%';
    }
  }
  if(mobileRangeMin){
    mobileRangeMin.addEventListener('input', () => {
      if (parseInt(mobileRangeMin.value) > parseInt(mobileRangeMax.value)) {
        mobileRangeMin.value = mobileRangeMax.value;
      }
      mobileupdateInputs();
      mobileupdateProgress();
    });
  }

  if(mobileRangeMax){
    mobileRangeMax.addEventListener('input', () => {
      if (parseInt(mobileRangeMax.value) < parseInt(mobileRangeMin.value)) {
        mobileRangeMax.value = mobileRangeMin.value;
      }
      mobileupdateInputs();
      mobileupdateProgress();
    });
  }

  if(mobileMinValueInput){
    mobileMinValueInput.addEventListener('change', () => {
      if (parseInt(mobileMinValueInput.value) > parseInt(mobileRangeMax.value)) {
        mobileMinValueInput.value = mobileRangeMax.value;
      }
      mobileupdateSlider();
    });
  }

  if(mobileMaxValueInput){
    mobileMaxValueInput.addEventListener('change', () => {
      if (parseInt(mobileMaxValueInput.value) < parseInt(mobileRangeMin.value)) {
        mobileMaxValueInput.value = mobileRangeMin.value;
      }
      mobileupdateSlider();
    });
  }

  // Initial update
  mobileupdateInputs();
  mobileupdateProgress();